var map = {
	"./consulting/working-with-us_2.svg": "0+48"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YPc7";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/working\-with\-us_2\.svg$
// module id = YPc7
// module chunks = 0